import {
	InsertProductImpressionTrackEventTypes,
	TrackRecommendedGameClickProps,
	IRecommendedGamesPersistLayer
} from './types';
import { eCommerceTrackEvent } from '../common';

const RECOMMENDED_GAMES_KEY = '_a_recom_g__p';
export const recommendedGamesPersistLayer: IRecommendedGamesPersistLayer = {
	get: () => {
		try {
			const storedValue = sessionStorage.getItem(RECOMMENDED_GAMES_KEY) as string;

			return JSON.parse(storedValue) as Record<string, unknown>;
		} catch (_) {
			return {};
		}
	},
	set: data => {
		sessionStorage.setItem(RECOMMENDED_GAMES_KEY, JSON.stringify(data));
	},
	remove: () => {
		sessionStorage.removeItem(RECOMMENDED_GAMES_KEY);
	}
};

export const insertProductImpressionTrackEvent = ({ impressions }: InsertProductImpressionTrackEventTypes) => {
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({
		event: 'EECproductImpression',
		ecommerce: {
			currencyCode: 'EUR',
			impressions
		}
	});
};

export const trackRecommendedGameClick = ({
	game,
	mode,
	list,
	position,
	category = ''
}: TrackRecommendedGameClickProps) => {
	const finalPos = position >= 0 ? position + 1 : undefined;

	recommendedGamesPersistLayer.set({
		position: finalPos,
		category
	});

	eCommerceTrackEvent({
		event: 'EECproductClick',
		eComObj: {
			currencyCode: 'EUR',
			click: {
				actionField: { list },
				products: [
					{
						name: game.name,
						id: game.gameId,
						category,
						variant: mode,
						position: finalPos
					}
				]
			}
		}
	});
};
